// extracted by mini-css-extract-plugin
export default {"adminSidebar":"Admin_adminSidebar__eA+4l"};